import React from "react";

export const arrangeScheduleHealthMetricsAutopatrol = (
  healthMetricsArray: any[]
) => {
  const metricOrder = [
    "scene_change_check",
    "stream_quality_check",
    "image_quality_check",
    "motion_status_check",
    "recording_check",
    "connectivity_check",
  ];

  const metricsByType = (healthMetricsArray || []).reduce(
    (acc: Record<string, any>, item: any) => {
      const metricType = item?.metric_type?.value;
      if (metricType) {
        acc[metricType] = item;
      }
      return acc;
    },
    {}
  );

  const orderedKnownMetrics = metricOrder
    .map((metricType) => metricsByType[metricType])
    .filter(Boolean);

  const remainingMetrics = (healthMetricsArray || []).filter((item: any) => {
    const metricType = item?.metric_type?.value;
    return !metricOrder.includes(metricType);
  });

  return [...orderedKnownMetrics, ...remainingMetrics];
};
